import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Home/ServicesHero.tsx");
